import * as Commons from "oc-commons/Commons";
import { Pfosten } from "./Pfosten";
import { v3 } from "oc-threejs/short3";
import { Vector3 } from "three";
import type { Arrangement } from "./Arrangement";
import type { Segment } from "./Segment";
import { Aufbau } from "./Aufbau";

export class Ecke {
  isEcke = true;

  pfosten: Pfosten = null;
  arrangement: Arrangement;
  /** Weltkoordinate */
  position = v3();
  segmente: Segment[] = [];
  anMauer = false;
  aufbauten: Aufbau[] = [];
  id = Commons.createId();
  gelöschterPfosten: Pfosten = null;

  constructor(arrangement: Arrangement) {
    this.arrangement = arrangement;
  }

  reset() {
    this.position.set(0, 0, 0);
    this.segmente = [];
  }

  toJSON() {
    return {
      position: this.position.toJSON(),
      pfosten: this.pfosten?.toJSON?.(),
    };
  }

  fromJSON(json: any) {
    if (json.position) this.position.fromJSON(json.position);
    if (json.pfosten) {
      this.ensurePfosten().fromJSON(json.pfosten);
    } else {
      this.pfosten = null;
    }
    return this;
  }

  ensurePfosten(pfostenZurPotentiellenVerwendung?: Pfosten): Pfosten {
    if (!this.pfosten) {
      if (
        pfostenZurPotentiellenVerwendung?.ecke != null &&
        pfostenZurPotentiellenVerwendung.ecke !== this
      ) {
        // Pfosten ist bereits einer anderen Ecke zugeordnet - nicht verwenden!
        pfostenZurPotentiellenVerwendung = null;
      }
      this.pfosten =
        this.gelöschterPfosten ?? pfostenZurPotentiellenVerwendung ?? new Pfosten(this.arrangement);
      // Falls der Pfosten einer anderen Ecke zugeordnet war (über gelöschterPfosten), diese Zuordnung aufräumen
      if (this.pfosten.ecke != null && this.pfosten.ecke !== this) {
        this.pfosten.ecke.pfosten = null;
      }
      this.pfosten.ecke = this;
    }
    if (!this.gelöschterPfosten) {
      this.pfosten.position.copy(this.position);
    }
    this.gelöschterPfosten = null;
    return this.pfosten;
  }

  getWorldPosition(): Vector3 {
    return this.position;
  }
}
